import {Controller, User} from '.'

let generateSortByField = (field) => (a, b) => {
    if (a[field] < b[field]) {
        return -1
    } else if (a[field] > b[field]) {
        return 1
    } else {
        return 0
    }
}

class Team {
    constructor(name = '', users = [], controllers = [], permissions = [], fields = [], integrations = [], dealership = false, beta_tester = false, id = null) {
        this.id = id
        this.name = name
        this.permissions = permissions
        this.controllers = controllers
        this.fields = []
        this.integrations = integrations
        this.dealership = dealership
        this.beta_tester = beta_tester

        if (users && users.length > 0) {
            this.users = users.map((obj) => User.fromAPIObject(obj, id)).sort(generateSortByField('name'))
        } else {
            this.users = []
        }

        if (fields && fields.length > 0) {
            this.fields = fields.sort(generateSortByField('field_number'))
        }
    }

    get dealer() {
        return this.dealership
    }

    get cons() {
        return this.controllers
    }

    get hasJDIntegration() {
        if (this.integrations && this.integrations.length) {
            return this.getIntegrationNamed(INTEGRATION_NAMES.JD_OPS_CENTER).length > 0
        } else {
            return false
        }
    }

    getIntegrationNamed(name) {
        if (this.integrations && this.integrations.length) {
            return this.integrations.filter(i => i.name === name)
        } else {
            return null
        }
    }

    static fromAPIObject(obj) {
        let controllers = []
        if (obj.controllers && obj.controllers.length) {
            controllers = obj.controllers.map((c) => Controller.fromAPIObject(c))
        }
        return new Team(obj.name, obj.members, controllers, obj.member_permissions, obj.fields, obj.integrations, obj.dealership, obj.beta_tester, obj.id)
    }
}

export const INTEGRATION_NAMES = {
    JD_OPS_CENTER: "John Deere Operations Center",
    UNKNOWN: "Unknown"
}

export default Team



// WEBPACK FOOTER //
// ./src/models/Team.js